import { noop } from "lodash-es";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

import { asReadonly } from "@/utils/vue";

export const useSidePanelStore = defineStore("sidePanel", () => {
  const left = ref({ width: 0, close: noop });
  const right = ref({ width: 0, close: noop });

  /**
   * @param close function to be called before another panels opens
   * @returns if the panel width could be set
   */
  function setWidth(side: "left" | "right", width: number, close: () => void) {
    const target = (side === "left" ? left : right).value;
    // different close function = a different panel is opened -> call close() on the old panel
    if (target.close !== close) {
      if (width === 0) {
        return false;
      }
      target.close();
    }
    target.close = width === 0 ? noop : close;
    target.width = width;
    return true;
  }

  return {
    left: asReadonly(left),
    right: asReadonly(right),

    panelLeftOpen: computed(() => left.value.width > 0),
    panelRightOpen: computed(() => right.value.width > 0),

    setWidth,
  };
});
